import { InputHTMLAttributes, forwardRef, useId } from "react";
import { TextInput } from "../../atoms/textInput/TextInput";
import { Label } from "../../atoms/Label";
import { InlineErrorMessage } from "../../atoms/Errors/InlineErrorMessage";

interface TextInputMoleculeProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  labelClassName?: string;
  description?: string;
  inlineerrormessage?: string;
  maxLength?: number;
  subtext?: string;
}

export const TextInputMolecule = forwardRef<
  HTMLInputElement,
  TextInputMoleculeProps
>(({ label, labelClassName, description, ...props }, ref) => {
  const id = useId();
  const maxLength = props.maxLength ?? 100;
  return (
    <div className="body-1 my-4">
      <Label
        htmlFor={props.id ?? id}
        text={label}
        className={labelClassName}
      />
      <div className="mb-3">{description}</div>
      {props?.subtext !== null && (
        <pre className="body-1 mb-6 whitespace-pre-wrap">{props.subtext}</pre>
      )}
      <InlineErrorMessage message={props.inlineerrormessage} />
      <TextInput
        {...props}
        id={props.id ?? id}
        ref={ref}
        maxLength={maxLength}
      />
    </div>
  );
});

TextInputMolecule.displayName = "TextInputMolecule";
